// extracted by mini-css-extract-plugin
export default {"preloader-wrapper":"style_preloader-wrapper__QT-cv","spin":"style_spin__8z-Yo"};